// extracted by mini-css-extract-plugin
export default {"weatherIconImage":"WeatherIcon_weatherIconImage__Vs4aZ"};